import { helpers, maxLength, required, numeric, integer, between } from '@vuelidate/validators';
import { commonCastDateValidationRules } from '@/common/commonValidations.js';
import { messageContent } from '@/common/messageContent.js';

const commonCreateUpdateValidations = () => {
  return {
    triggerData: {
      title: {
        required: helpers.withMessage(messageContent.requireInput('タイトル'), required),
        maxlength: helpers.withMessage(
          messageContent.requireUnderMaximumNumberOfCharacters('タイトル', 16),
          maxLength(16)
        ),
      },
      text: {
        required: helpers.withMessage(messageContent.requireInput('テキスト'), required),
        maxlength: helpers.withMessage(
          messageContent.requireUnderMaximumNumberOfCharacters('テキスト', 35),
          maxLength(35)
        ),
      },
      scheduleBusinessDays: {
        required: helpers.withMessage(messageContent.requireInput('通知タイミング(営業日)'), required),
        numeric: helpers.withMessage('通知タイミング(営業日)は数字で入力してください。', numeric),
        integer: helpers.withMessage('通知タイミング(営業日)は整数で入力してください。', integer),
        between: helpers.withMessage('通知タイミング(営業日)は1から99の間で入力してください。', between(1, 99)),
      },
      scheduleTime: {
        required: helpers.withMessage(messageContent.requireSelect('配信時刻'), required),
      },
      deliveryStartDate: {
        required: helpers.withMessage(messageContent.requireInput('配信開始日'), required),
        notPastDate: helpers.withMessage(
          messageContent.setDeliveryStartDateToPastDateTime,
          (value, vm) => {
            if (value === vm.originalTriggerData?.deliveryStartDate) {
              return true;
            }
            // 共通のバリデーションルールを使用する
            return commonCastDateValidationRules.validateSetCastDateToPastDateTime(value, { checkStatus: '' });
          }
        ),
        setDeliveryEndDateBeforePastDateTime: helpers.withMessage(
          messageContent.setDeliveryEndDateBeforeDeliveryStartDate,
          (value, vm) => {
            // deliveryEndDateはvmのトップレベルにあるので、vm.deliveryEndDateでアクセス
            if (!value || !vm.deliveryEndDate) {
              return true;
            }
            return value < vm.deliveryEndDate;
          }
        ),
      },
      deliveryEndDate: {
        required: helpers.withMessage(messageContent.requireInput('配信終了日'), required),
      },
    },
  };
};

export const triggerValidation = {
  update: () => {
    return commonCreateUpdateValidations();
  },
};
